import React from "react";
import { Section, Eyebrow, Reveal, KW } from "./shared";
import { WHY_YT } from "../../lib/site";

export default function WhyYouTube() {
  return (
    <Section id="why-youtube" bg="bg-white">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#E90019">Why YouTube</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          Your Best Content Shouldn&rsquo;t <KW c="#E90019">Disappear</KW> Tomorrow
        </h2>
        <p className="text-base sm:text-lg text-brand-ink/75 mt-5">
          YouTube combines search, discovery, long-form education, and trust in one platform—so useful videos can continue working for your business long after you publish them.
        </p>
      </Reveal>

      {/* Staggered panels */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {WHY_YT.map((w, i) => (
          <Reveal key={w.t} delay={(i % 3) * 0.08}>
            <div
              className={`h-full rounded-[26px] border-2 border-brand-black bg-brand-cream p-6 sm:p-7 transition-transform duration-300 hover:-translate-y-1.5 ${
                i % 3 === 1 ? "lg:mt-8" : ""
              } ${i % 3 === 2 ? "lg:mt-4" : ""}`}
              style={{ boxShadow: "8px 10px 0 #111111" }}
            >
              <span className="font-display text-3xl text-brand-black/15">0{i + 1}</span>
              <h3 className="font-bold text-lg sm:text-xl mt-2">{w.t}</h3>
              <p className="text-sm text-brand-ink/75 mt-2 leading-relaxed">{w.d}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 rounded-[32px] border-2 border-brand-black bg-brand-blue text-white p-8 sm:p-12 grid sm:grid-cols-2 gap-4 items-center"
          style={{ boxShadow: "10px 12px 0 #FFCB52" }}>
          <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight">Paid Traffic Is Rented.</h3>
          <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight text-brand-yellow sm:text-right">Strategic Content Is an Asset.</h3>
        </div>
      </Reveal>
    </Section>
  );
}
